import { render, staticRenderFns } from "./ActiveClaims.vue?vue&type=template&id=7c84a385&scoped=true"
import script from "./ActiveClaims.vue?vue&type=script&lang=js"
export * from "./ActiveClaims.vue?vue&type=script&lang=js"
import style0 from "./ActiveClaims.vue?vue&type=style&index=0&id=7c84a385&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c84a385",
  null
  
)

export default component.exports